import { useEffect } from 'react'
import { I18nProviderClient, useCurrentLocale } from '_/i18n/config-client'
import type { Locale } from '_/i18n/dictionaries/types'

type Props = {
	locale?: Locale
	children: React.ReactNode
}

const DocumentLanguage = () => {
	const locale = useCurrentLocale()
	useEffect(() => {
		document.documentElement.lang = locale
	}, [locale])
	return null
}

const LocaleProviders = ({ locale, children }: Props) => {
	return (
		<I18nProviderClient locale={locale}>
			<DocumentLanguage />
			{children}
		</I18nProviderClient>
	)
}

export { LocaleProviders }
